import { OrgId } from '../organization';
import { CompactUserResponse, UserId } from '../account';
import { TaskPriority } from '@business/constants/task';
import { TaskStatusResponse, TaskStatusId } from '../task_status';

export type TaskId = string;
export interface TaskResponse {
  id: TaskId;
  title: string;
  content?: string;
  priority: TaskPriority;
  dueDate?: number;
  isCompleted: boolean;
  completedBy?: CompactUserResponse;
  completedAt?: number;
  menuOrder: number;
  author: CompactUserResponse;
  assignee: UserId[];
  assigneeUsers: CompactUserResponse[];
  orgId?: OrgId;
  organization?: string;
  parentId?: TaskId;
  children: TaskResponse[];
  createdAt: number;
  statusId: TaskStatusId;
  status: TaskStatusResponse;
  parentTitle?: string;
  objectId?: string;
  objectType?: string;
  comments: number;
  timeEstimate?: number; // Time estimate in minutes
}

export type TaskOrderRequest = Pick<TaskResponse, 'id' | 'menuOrder'>[];

export enum TodoTaskStatus {
  completed = 'completed',
  pending = 'pending',
}

export interface TodoTasksRequest {
  status?: TodoTaskStatus;
  search?: string;
  page?: number;
  id?: string;
  priority?: TaskPriority;
}

export interface TodoTasksResponse {
  data: TaskResponse[];
  meta: TasksMetaResponse;
}

export interface TasksMetaResponse {
  total: number;
  page: number;
  perPage: number;
}

export interface FetchTaskCountResponse {
  pending: number;
  completed: number;
}

export interface TaskTextSearchResult {
  id: number;
  title: string;
  contentPreview: string;
  dueDate?: string;
  isCompleted: boolean;
  type: 'parent' | 'subtask' | 'comment';
  parentId?: number;
  parentTitle?: string;
  commentId?: number;
  taskId?: number;
  taskTitle?: string;
  authorName?: string;
  createdAt?: number;
  commentPreview?: string;
}

export interface TaskTextSearchResponse {
  query: string;
  results: {
    parentTasks: TaskTextSearchResult[];
    subtasks: TaskTextSearchResult[];
    comments: TaskTextSearchResult[];
  };
  totalResults: number;
}
